// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__8SiB8","spinner":"spinner_spinner__nuXtI","item":"spinner_item__9gNIa","lds-spinner":"spinner_lds-spinner__iQLGm"};